import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { isAdminPath } from '../utils/adminArea'

// Wraps site-only extras (toasts, install prompts) so they stay out of the admin console.
export default function SiteOnly({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  return isAdminPath(pathname) ? null : <>{children}</>
}
